// JavaScript Document
$(function(){
	let target1 = $("#parallax-01");
	let targetPosOT1 = target1.offset().top;
	let targetFactor = 0.2;
	let windowH = $(window).height();
	let scrollYStart1 = targetPosOT1 - windowH;
	/*挙動を起こさせるためのJquery↓*/
	$(window).on('scroll',function(){
		let scrollY = $(this).scrollTop();
		if(scrollY > scrollYStart1){
			target1.css('background-position-y',(scrollY - targetPosOT1) * targetFactor + 'px');
		}else{
			target1.css('background-position','center top');
		}
		
	});/*$(window)*/
});/*$(fucntion)*/
$(function(){
		$('a[href^=#]').click(function(){
			let speed = 1000;
			let href= $(this).attr("href");
			let target = $(href == "#" || href == "" ? 'html' : href);
			let position = target.offset().top;
			$("html, body").animate({scrollTop:position}, speed, "swing");
			return false;
			});
		});
